import {View, Text, Modal, TouchableOpacity, ScrollView} from 'react-native';
import React, {useEffect, useState} from 'react';
import Feather from 'react-native-vector-icons/Feather';
import {Colors} from '../../../../constants/Colors';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import {styles} from './styles';
import Input from '../../../../components/Input/Input';

interface IModalDesactive {
  visible: boolean;
  onRequestClose: () => void;
  onDesactive: (password: string) => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

const ModalDesactive = ({
  visible,
  onRequestClose,
  onDesactive,
  title = 'Confirmação',
  message = 'Para desativar sua conta, digite sua senha.',
  confirmLabel = 'Sim',
  cancelLabel = 'Não',
}: IModalDesactive) => {

  const [password, setPassword] = useState('');

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <View style={styles.spaceHorizontal}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
            <Text style={styles.filterText}>{title}</Text>
          </View>
          <View style={styles.spaceHorizontal}>
            <Text style={styles.information}>
              {message}
            </Text>
            <Input
              title="Senha"
              placeholder="Senha..."
              hasSecurity
              mt={30}
              value={password}
              onChangeText={text =>
                setPassword(text)
              }
            />
          </View>

          <View style={styles.containerButton}>
            <ButtonComponent
              title={cancelLabel}
              outlined
              width="48%"
              onPress={() => {
                onRequestClose();
              }}
            />
            <ButtonComponent
              title={confirmLabel}
              width="48%"
              onPress={() => {
                onDesactive(password);
              }}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ModalDesactive;
